<div class="splash-container" id="splash-container">
  <div class="splash-container-images" id="splash-container-images">
    <div class="row justify-content-center" id="row-header">
      <div class="col-12 text-center" id="col-header">
        <h2 class="submit-quote" id="submit-quote-heading">
          Submit Your Quote
        </h2>
        <p class="submit-quote-text" id="submit-quote-text-1">
          You are about to submit a quote request.
        </p>
        <p class="submit-quote-text mt-minus" id="submit-quote-text-2">
          Please select your preferred mode:
        </p>
      </div>
    </div>
    <div class="row justify-content-center mt-5" id="row-form">
      <div class="col-10" id="col-form">
        <div class="card" id="card-form">
          <form [formGroup]="quoteForm" (ngSubmit)="submit()" id="quote-form">
            <div class="form-check mb-3" id="form-check-sandbox">
              <input
                class="form-check-input"
                type="radio"
                id="sandbox"
                value="sandbox"
                formControlName="mode"
              />
              <label class="form-check-label" for="sandbox" id="label-sandbox">
                Sandbox Mode:
              </label>
              <div class="description" id="description-sandbox">
                Test the submission process. Your quote will not be sent or
                saved. This option is ideal for training or system testing.
              </div>
            </div>
            <div class="form-check mb-3" id="form-check-business">
              <input
                class="form-check-input"
                type="radio"
                id="business"
                value="business"
                formControlName="mode"
              />
              <label
                class="form-check-label"
                for="business"
                id="label-business"
              >
                Business Development Mode:
              </label>
              <div class="description" id="description-business">
                Proceed with submitting your quote to a real account. Please
                select the account from the dropdown below that you own in
                Salesforce.
              </div>
            </div>
            <div
              *ngIf="quoteForm.get('mode')?.value === 'business'"
              id="business-mode-fields"
            >
              <div class="form-check mt-3" id="form-check-customer">
                <label for="customer" id="label-customer">Customer</label>
                <p-dropdown
                  id="customer"
                  [options]="customers"
                  optionLabel="customer_name"
                  formControlName="customer"
                  [filter]="true"
                  filterBy="customer_name"
                  placeholder="Select a Customer"
                ></p-dropdown>
                <small
                  *ngIf="
                    quoteForm?.get('customer')?.invalid &&
                    (quoteForm?.get('customer')?.dirty ||
                      quoteForm?.get('customer')?.touched)
                  "
                  class="required-field"
                  id="required-customer"
                  >Required Field</small
                >
              </div>
              <div class="form-check mt-3" id="form-check-contact">
                <label for="contact" id="label-contact">Contact</label>
                <p-dropdown
                  id="contact"
                  [options]="contacts"
                  formControlName="contact"
                  [filter]="true"
                  filterBy="first_name,last_name"
                  placeholder="Select a Contact"
                >
                  <ng-template let-contact pTemplate="item">
                    {{ contact.first_name }} {{ contact.last_name }}
                  </ng-template>
                  <ng-template let-selectedContact pTemplate="selectedItem">
                    {{ selectedContact.first_name }}
                    {{ selectedContact.last_name }}
                  </ng-template>
                </p-dropdown>
                <small
                  *ngIf="
                    quoteForm?.get('contact')?.invalid &&
                    (quoteForm?.get('contact')?.dirty ||
                      quoteForm?.get('contact')?.touched)
                  "
                  class="required-field"
                  id="required-contact"
                  >Required Field</small
                >
              </div>
            </div>
            <div class="button-group mt-4" id="button-group">
              <button
                class="splash-button cancel"
                (click)="cancel()"
                pButton=""
                type="button"
                label=""
                id="button-cancel"
              >
                Cancel
              </button>
              <button
                [disabled]="!quoteForm.valid"
                class="splash-button"
                pButton=""
                type="submit"
                label=""
                id="button-submit"
              >
                Submit
              </button>
            </div>
          </form>
          <p class="note mt-4" id="note">
            In order to ensure your quote is processed correctly, please review
            your selection. If you have any questions or need assistance,
            <a
              href="https://www.trinityrail.com/contact/"
              target="_blank"
              style="color: #287da1; text-decoration: underline"
              id="contact-link"
              >contact support</a
            >.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
